import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getNews, type NewsItem } from '@/shared/services/eventsService';
import { SectionTitle } from './SectionTitle';
import { newsImg, newsImgFallback } from '@/shared/utils/newsImg';

type NewsCard = { id: number | null; image: string; date: string; title: string; text: string };

// Conteudo editorial do layout aprovado — so' aparece se a API nao trouxer noticia.
const FALLBACK: NewsCard[] = [
  { id: null, image: '/assets/liberty/news-main.webp', date: '23/09/2026', title: 'Abertura do servidor\nestá próxima', text: 'Duas forças, um só chamado — a nova era do Cabal Liberty está prestes a começar.' },
  { id: null, image: '/assets/liberty/news-2.webp', date: '17/08/2026', title: 'O auge do poder chegou', text: 'Evento relâmpago no ar por 10 dias. Cabal Liberty liberou o evento “O Auge do Poder”.' },
  { id: null, image: '/assets/liberty/news-3.webp', date: '16/07/2026', title: 'Duas reuniões marcadas', text: 'Reunião geral com os líderes & players. Vamos alinhar os próximos passos.' },
  { id: null, image: '/assets/liberty/news-4.webp', date: '11/07/2026', title: 'Patch notes 1.1', text: 'Desperte o poder. Defenda a liberdade. Confira todas as mudanças.' },
];

// Imagem padrao por posicao quando a noticia nao tem capa.
const FALLBACK_IMG = FALLBACK.map((n) => n.image);

// Tira tags + decodifica entities (&amp; -> &, &#128680; -> emoji).
function stripHtml(s: string) {
  if (!s) return '';
  const noTags = s.replace(/<[^>]+>/g, ' ');
  const t = document.createElement('textarea');
  t.innerHTML = noTags;
  return t.value.replace(/\s+/g, ' ').trim();
}

function toCard(n: NewsItem, i: number): NewsCard {
  return {
    id: n.id,
    image: n.image || FALLBACK_IMG[i] || FALLBACK_IMG[0],
    date: new Date(n.createdDate).toLocaleDateString('pt-BR'),
    title: n.title,
    text: n.subTitle || stripHtml(n.html),
  };
}

export function NewsSection() {
  const navigate = useNavigate();
  const [cards, setCards] = useState<NewsCard[] | null>(null);

  useEffect(() => {
    getNews()
      .then((list) => setCards(list.length ? list.slice(0, 4).map(toCard) : FALLBACK))
      .catch(() => setCards(FALLBACK));
  }, []);

  const open = (c: NewsCard) => navigate(c.id != null ? `/news/${c.id}` : '/news');
  const [main, ...side] = cards ?? [];

  return (
    <section className="section news" id="noticias">
      <div className="shell">
        <SectionTitle
          title="Notícias"
          subtitle="Fique por dentro de tudo que acontece no Cabal Liberty"
          action={<Link className="outline-btn" to="/news">Ver todas as notícias <span>›</span></Link>}
        />

        <div className="news-frame fantasy-frame reveal">
          {main && (
            <>
              <article className="news-main" onClick={() => open(main)} style={{ cursor: 'pointer' }}>
                <img src={newsImg(main.image, 960)} onError={newsImgFallback(main.image)} alt={main.title} />
                <div className="news-main-shade"></div>
                <div className="news-main-content">
                  <span className="badge">Destaque</span>
                  <time>{main.date}</time>
                  <h3>{main.title.split('\n').map((l, i) => <Fragment key={i}>{i > 0 && <br />}{l}</Fragment>)}</h3>
                  <p>{main.text}</p>
                  <button className="tiny-btn">Ler mais <span>›</span></button>
                </div>
              </article>
              <div className="news-side">
                {side.map((n, i) => (
                  <article key={n.id ?? `fb-${i}`} onClick={() => open(n)} style={{ cursor: 'pointer' }}>
                    <img src={newsImg(n.image, 480)} onError={newsImgFallback(n.image)} loading="lazy" alt={n.title} />
                    <div><time>{n.date}</time><h4>{n.title}</h4><p>{n.text}</p></div>
                  </article>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
